import { render, staticRenderFns } from "./Buttons.vue?vue&type=template&id=b9e735e4&scoped=true&"
import script from "./Buttons.vue?vue&type=script&lang=js&"
export * from "./Buttons.vue?vue&type=script&lang=js&"
import style0 from "./Buttons.vue?vue&type=style&index=0&id=b9e735e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e735e4",
  null
  
)

export default component.exports